var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "brandBtn text-center pointer prelative",
      class: { stretch: _vm.stretch, negative: _vm.negative },
    },
    [
      _c("div", { staticClass: "d-flex justify-center" }, [
        _c("div", { staticClass: "tt titleFont oneLiner" }, [
          _vm._v(_vm._s(_vm.content)),
        ]),
        _c(
          "div",
          {
            staticClass: "text-right align-self-center",
            staticStyle: { position: "absolute", right: "0.5em" },
          },
          [
            _c("v-icon", { staticClass: "myAccent" }, [
              _vm._v("mdi-chevron-right"),
            ]),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }